import $ from "jquery";

$(function() {
  $(".show-modal").on("click", function(e) {
    e.preventDefault();

    var target = $(this).attr("href");

    $("body").addClass("show-modal");
    $(target).addClass("active");
  });

  $(".modal__close").on("click", function() {
    $(this)
      .parents(".modal.active")
      .removeClass("active");
    $("body").removeClass("show-modal");
  });
});
